import styled from "@emotion/styled";
import { noop } from "lodash";
import * as React from "react";

import { DesignToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import { Switch } from "components/switch";
import { withVar } from "themes/helpers";

interface IProps {
  isPrivate: boolean;
  disabled?: boolean;
  onClick(e: React.MouseEvent<HTMLDivElement>): void;
  onMouseDown(e: React.MouseEvent<HTMLDivElement>): void;
}

const SwitchWrapper = styled.div<IProps>`
  display: flex;
  align-items: center;
  position: relative;
  padding-right: var(${SpacingToken.Spacing4});
  ${({ disabled }): string => (!disabled ? "cursor: pointer" : "")};

  &:after {
    content: "";
    width: 1px;
    height: 15px;
    background: ${({ isPrivate }): string =>
      withVar(isPrivate ? DesignToken.BorderInvertSecondary : DesignToken.BorderBasicSecondary)};
    position: absolute;
    top: 3px;
    right: 8px;
  }
`;

interface ISwitchLabel {
  isPrivate: boolean;
}

const SwitchLabel = styled(Text)<ISwitchLabel>`
  margin-left: 6px;
  color: ${({ isPrivate }): string =>
    withVar(isPrivate ? DesignToken.ContentInvertPrimary : DesignToken.ContentBasicPrimary)};
`;

export const TicketPrivateMessageSwitch: React.FC<IProps> = ({ isPrivate, disabled, onClick, onMouseDown }) => (
  <SwitchWrapper
    isPrivate={isPrivate}
    disabled={disabled}
    onClick={disabled ? noop : onClick}
    onMouseDown={onMouseDown}
  >
    <Switch on={isPrivate || undefined} size="small" disabled={disabled} />
    <SwitchLabel size="sm" isPrivate={isPrivate}>
      Private
    </SwitchLabel>
  </SwitchWrapper>
);

export default React.memo(TicketPrivateMessageSwitch);
